/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ agent: NonNullable<unknown> }} Audit_Details_Agent_Unattended_Destructive_Reset_By_Sharing_DescInputs */



/**
* | output |
* | --- |
* | "The agent \"{agent}\" was shared more widely, so its permission to take irreversible actions without human approval was reset. On a shared agent only an admini..." |
*
* @param {Audit_Details_Agent_Unattended_Destructive_Reset_By_Sharing_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_details_agent_unattended_destructive_reset_by_sharing_desc = /** @type {((inputs: Audit_Details_Agent_Unattended_Destructive_Reset_By_Sharing_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Details_Agent_Unattended_Destructive_Reset_By_Sharing_DescInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Der Agent "${i?.agent}" wurde breiter geteilt, daher wurde seine Freigabe für unumkehrbare Aktionen ohne menschliche Genehmigung zurückgesetzt. Auf einem geteilten Agenten kann nur eine Administratorin oder ein Administrator sie erneut erteilen.`)
	return /** @type {LocalizedString} */ (`The agent "${i?.agent}" was shared more widely, so its permission to take irreversible actions without human approval was reset. On a shared agent only an administrator can grant it again.`)
});